import React, { useState } from 'react'
import './styles.scss'
import { Link, withRouter } from 'react-router-dom'
import EditableLocalAdminInformationForm from './EditableLocalAdminInformationForm/EditableLocalAdminInformationForm'

const EditableLocalAdminInformation = (props) => {

    const [title, setTitle] = useState('Loading...')

    return (
        <div className='EditableLocalAdminInformation'>
            <div className="back">
                <Link to='/devices' />
                <div className="wide-container">
                    <div className="h1">
                        {
                            props.match.params.userId === 'new'
                                ? 'New Regional Admin Profile'
                                : title
                        }
                    </div>
                </div>
            </div>
            <div className="wide-container profile-block">
                <EditableLocalAdminInformationForm userId={props.match.params.userId} updateTitle={setTitle} />
            </div>
        </div>
    )
}

export default withRouter(EditableLocalAdminInformation)